export default __webpack_public_path__ + "static/media/1641.af96d43d.png";